import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import LiveDatasheet from '../LiveDatasheet/LiveDatasheet';
import ErrorPage from '../ErrorPage/ErrorPage';
import GenHelp from '../GenHelp/GenHelp';

export default function App() {
	return (
		<>
			<Routes>
				<Route path="/:partName" element={<LiveDatasheet />} />
				<Route path="*" element={<ErrorPage />} />
				<Route path="/genhelp" element={<GenHelp />} />
			</Routes>
			<Footer />
		</>
	);
}
